import authService from "../components/api-authorization/AuthorizeService";

export const fetchWrapper = {
  get,
  getWithAuth,
  downloadFileFromPostWithAuth,
  downloadFile,
  downloadFileWithAuth,
  post,
  postWithAuth,
  sendFilesWithAuth,
  put,
  putWithAuth,
  delete: _delete,
  deleteWithAuth: _deleteWithAuth,
};

function getAccessToken() {
  return authService.getAccessToken();
}

function get(url: string) {
  const requestOptions = {
    method: "GET",
  };
  return fetch(url, requestOptions).then(handleResponse);
}

async function getWithAuth(url: string) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  return fetch(url, requestOptions).then(handleResponse).catch(handleError);
}

async function downloadFileFromPostWithAuth(url: string, body: {}) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions)
    .then((response) => response.blob())
    .then((blob: any) => {
      return blob;
    });
}

async function downloadFileWithAuth(url: string) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/pdf",
    },
  };
  return fetch(url, requestOptions)
    .then((response) => response.blob())
    .then((blob: any) => {
      return blob;
    });
}

async function downloadFile(url: string) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  };
  return fetch(url, requestOptions)
    .then((response) => response.blob())
    .then((blob: any) => {
      return blob;
    });
}

function post(url: string, body: {}) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(handleResponse);
}

async function postWithAuth(url: string, body: {}) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(handleResponse);
}

async function sendFilesWithAuth(url: string, data: any) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: data,
  };
  return fetch(url, requestOptions).then(handleResponse);
}

function put(url: string, body: {}) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(handleResponse);
}

async function putWithAuth(url: string, body: {}) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url: string) {
  const requestOptions = {
    method: "DELETE",
  };
  return fetch(url, requestOptions).then(handleResponse);
}

async function _deleteWithAuth(url: string) {
  const token = await getAccessToken();
  if (token == null) {
    throw new Error("Not authorized!");
  }
  const requestOptions = {
    headers: { Authorization: `Bearer ${token}` },
    method: "DELETE",
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// helper functions

function handleError(response: any) {
  return Promise.reject(response);
}

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    if (response.ok) {
      try {
        const data = text && JSON.parse(text);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    } else {
      const data = text && JSON.parse(text);
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
  });
}
